<template>
  <div class="plugin-container">
    <bimContainer>
      <BlockHead />
    </bimContainer>
    <BlockDownloadPlugin class="block-plugin mx-auto d-none d-lg-flex mb-10" ref="block_plugin" />
    <BlockWhyBIMLIBPlugin />
    <BlockActionTime />
    <bimPopup title="" v-model="videoPopup" width="90vw" closeOnWrapper>
      <div class="plugin-video">
        <vue-plyr v-metric="'LENDING-SMPP_CLICK-ON-VIDEO'">
          <div data-plyr-provider="youtube" data-plyr-embed-id="Z8iWKMLAYGs"></div>
        </vue-plyr>
      </div>
    </bimPopup>
  </div>
</template>

<script>
import bimPopup from "@bimlib/components/bimPopup"
import bimContainer from "@bimlib/components/bimContainer"

import BlockHead from "./components/BlockHead"
import BlockDownloadPlugin from "./components/BlockDownloadPlugin"
import BlockWhyBIMLIBPlugin from "./components/BlockWhyBIMLIBPlugin"
import BlockActionTime from "./components/BlockActionTime"

export default {
  name: "LandingPlugin",
  components: {
    bimPopup,
    bimContainer,

    BlockHead,
    BlockDownloadPlugin,
    BlockWhyBIMLIBPlugin,
    BlockActionTime
  },
  data() {
    return {
      videoPopup: false,
    }
  },
  mounted() {
    this.initPluginCalculatePosition()
  },
  methods: {
    initPluginCalculatePosition() {
      const plugin = this.$refs.block_plugin.$el
      const scrollPlugin = {
        plugin,
        position: window.pageYOffset,
        down () {
          this.plugin.style.top = "84px"
          this.position = window.pageYOffset
        },
        up () {
          setTimeout(() => {
            this.plugin.style.top = "20px"
          }, 300)
          this.position = window.pageYOffset
        },
        init () {
          if (this.plugin) {
            window.addEventListener('scroll', () => {
              if (this.position < window.pageYOffset && window.pageYOffset >= 200) {
                this.up()
              } else if (window.pageYOffset === 0) {
                setTimeout(() => {
                  this.down()
                }, 1000)
              } else {
                this.down()
              }
            })
          }
        }
      }
      window.addEventListener("load", ( ) => scrollPlugin.init())
    }
  }
}
</script>

<style lang="scss" scoped>
.plugin-container {
  background-color: #f8f8f8;
}

.block-plugin {
  position: sticky;
  top: 0;
  z-index: 99;
}

.plugin-video {
  width: 679px;
  max-width: 100%;
}
</style>
